module.exports = __webpack_public_path__ + "img/4.04d278b3.png";